import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import { makeStyles } from "@material-ui/core/styles";
import classNames from "classnames";
import React from "react";
import { FormattedMessage } from "react-intl";

const useStyles = makeStyles(
  theme => ({
    addTopMargin: {
      marginTop: "10px",
      paddingBottom: "10px"
    },
    formControl: {
      "& label": {
        top: "-3px"
      },
      width: "100%"
    },
    labelAsterisk: {
      color: "red"
    },
    loweredDropdown: {
      marginTop: "54px"
    },
    noLabel: {
      padding: theme.spacing(2, 1.5)
    },
    root: {
      "&.Mui-disabled": {
        color: "#000000"
      },
      "&.MuiMenuItem-root": {
        color: "#000000"
      }
    }
  }),
  { name: "RemittanceManualAdjustmentDropdown" }
);

interface RemittanceManualAdjustmentDropdownProps {
  choices: Array<{
    value: string;
    label: string | React.ReactNode;
  }>;
  disabled?: boolean;
  label?: string;
  name?: string;
  placeholder?: string;
  value?: string;
  isRequired: boolean;
  onChange(event: any);
}

export const RemittanceManualAdjustmentDropdown: React.FC<RemittanceManualAdjustmentDropdownProps> = props => {
  const {
    label,
    choices,
    value,
    isRequired,
    onChange,
    placeholder,
    name,
    disabled
  } = props;
  const classes = useStyles(props);

  return (
    <FormControl
      disabled={disabled}
      fullWidth
      className={classNames(classes.formControl, classes.addTopMargin)}
    >
      <InputLabel
        classes={
          isRequired
            ? {
                asterisk: classes.labelAsterisk
              }
            : null
        }
        required={isRequired}
        shrink={true}
      >
        {label}
      </InputLabel>
      <Select
        id={label ? `${label.replace(/: /g, "").toLowerCase()}Dropdown` : name}
        value={value}
        variant="outlined"
        onChange={onChange}
        displayEmpty
      >
        <MenuItem value="" disabled={true} className={classes.root}>
          {placeholder}
        </MenuItem>
        {choices?.length > 0 ? (
          choices.map((choice, index) => (
            <MenuItem
              data-test="selectFieldOption"
              data-test-id={choice.value}
              value={choice.value}
              key={choice.value}
              id={`optionRow${index}`}
            >
              {choice.label}
            </MenuItem>
          ))
        ) : (
          <MenuItem
            data-test="selectFieldOption"
            data-test-disabled
            disabled={true}
          >
            <FormattedMessage defaultMessage="No results found" />
          </MenuItem>
        )}
      </Select>
    </FormControl>
  );
};
RemittanceManualAdjustmentDropdown.displayName =
  "RemittanceManualAdjustmentDropdown";
export default RemittanceManualAdjustmentDropdown;
